<template>
  <div id="app">
    <router-view />
    <BackToTop />

    <div class="loading-box df fdc aic jcc" v-show="loading">
      <p> <img src="@/assets/images/img/loader.gif" alt=""></p>
      <p class="mt-12">{{ $t(loadingText) }}</p>
    </div>
  </div>
</template>

<script>
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import { getUrlLocale } from '@/utils/url';
import Cookies from 'js-cookie';

export default {
  name: "App",
  // watch: {
  //   $route: {
  //     handlder(to, from) {
  //       console.log("pc APP", to);
  //     },
  //     immdediate: true,
  //   },
  // },
  data() {
    return {
      loading: false, // 控制loading显示隐藏,
      loadingText: this.$t('加载中')+'...', // loading上面的文字
    };
  },

  created() {

    // 监听显示Loading事件
    this.$bus.$on('showLoading', (text) => {
      this.showLoading(text)
    })

    // 监听隐藏Loading事件
    this.$bus.$on('hideLoading', () => {
      this.hideLoading()
    })

  },
  mounted() {




    // this.$i18n.locale = lang; // 修改当前语言

    let Language = localStorage.getItem('currentLanguage');  //获取本地语言

    if (Language && Language != 'zh') {
      locale.use(lang)
    }

    if (Language) {
      this.$i18n.locale = Language;
    } else {
      this.$i18n.locale = "zh";
    }
    document.addEventListener("visibilitychange", this.onVisibilitychange);
  },
  unmounted() {
    document.removeEventListener("visibilitychange", this.onVisibilitychange);
  },

  methods: {

    // 显示loading
    showLoading(text = this.$t('加载中')+'...') {
      this.loadingText = text
      this.loading = true
    },

    // 隐藏Loading
    hideLoading() {
      this.loading = false
    },


    onVisibilitychange(v) {
      if (document.hidden) {
        // 页面隐藏时的钩子，可按需添加逻辑
      } else {
        // 设置缓存为当前路径对应语言的缓存
        let locale = getUrlLocale();
        if (locale == 'cn') {
          locale = 'zh'
        }

        // 更改语言
        this.$i18n.locale = locale;

        // 更改cookie
        const siteDataList = {
          en: '{"tws_id":2,"apply_site":"protal_en"}',
          zh: '{"tws_id":1,"apply_site":"protal"}'
        }
        Cookies.set('siteData', siteDataList[locale]);

        // 更改本地缓存
        localStorage.setItem('currentLanguage', locale);
      }
    }
  },

  beforeDestroy() {
    // 移除事件监听，防止内存泄漏
    this.$bus.$off('showLoading')
    this.$bus.$off('hideLoading')
  },
};
</script>

<style lang="scss" scoped>
.loading-box {
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000000, $alpha: 0.4);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999;

  p {
    text-align: center;
    // font-size: 3.27vw;
    font-family: "harmonyos";
    color: #ffffff;
    margin-right: 2vw;
  }

  img {
    width: 24px;
  }
}
</style>
